import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Dialog from "material-ui/Dialog";
import { CloseIcon } from "./icons";
import { S } from "./constants";
import {
  colors,
  btn,
  card,
  form,
  table,
} from "../../../../style/common/partnerStyle";

// ── Knockout Leaderboard Popup ────────────────────────────────────────────────

export class KnockoutLeaderBoardPopup extends PureComponent {
  static propTypes = {
    leader_board: PropTypes.array.isRequired,
    competition_game: PropTypes.object,
    knockout_matches_created: PropTypes.bool,
    zones: PropTypes.array,
    selected_zone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    leaderboard_loading: PropTypes.bool,
    selected_rows: PropTypes.array,
    cup_shield_bowl_type: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onHandleKnockout: PropTypes.func.isRequired,
    onZoneChange: PropTypes.func.isRequired,
    onClickCreate: PropTypes.func.isRequired,
    onCupShieldBowlTypeChange: PropTypes.func.isRequired,
    onClickCreateCupShieldBowl: PropTypes.func.isRequired,
  };

  renderSkeletonRows(count) {
    var rows = [];
    var headers = ["", "#", "Team", "Played", "Won", "Draw", "Lost", "For", "Against", "Diff", "Points", ""];
    for (var i = 0; i < count; i++) {
      rows.push(
        <tr key={i}>
          {headers.map(function (h, hi) {
            return (
              <td key={hi} style={S.tdCenter}>
                <div className="skeleton-box" />
              </td>
            );
          })}
        </tr>
      );
    }
    return rows;
  }

  render() {
    var self = this;
    var {
      leader_board,
      knockout_matches_created,
      zones,
      selected_zone,
      leaderboard_loading,
      selected_rows,
      cup_shield_bowl_type,
      onClose,
      onHandleKnockout,
      onZoneChange,
      onClickCreate,
      onCupShieldBowlTypeChange,
      onClickCreateCupShieldBowl,
    } = this.props;

    var safeSelectedRows = selected_rows || [];
    var csbType = cup_shield_bowl_type || 'cup';

    // ── CSB accent colour ──────────────────────────────────────────────────────
    var csbColor = csbType === 'cup' ? '#f59e0b' : csbType === 'shield' ? '#6366f1' : '#10b981';

    var leaderboardModal = Object.assign({}, S.modal, { maxWidth: 900 });

    var tdTeam = Object.assign({}, table.tdBold, {
      padding: "10px 12px",
      whiteSpace: "normal",
      wordBreak: "break-word",
      maxWidth: 180,
    });

    var thCenter     = Object.assign({}, table.th, { textAlign: "center" });
    var thCenterBrand= Object.assign({}, table.th, { textAlign: "center", color: colors.brand });
    var thRank       = Object.assign({}, table.th, { textAlign: "center", width: 36 });
    var thCheck      = Object.assign({}, table.th, { width: 36 });
    var thCheckCsb   = Object.assign({}, table.th, { width: 36, color: csbColor });
    var tdRank       = Object.assign({}, S.tdCenter, { width: 36, fontWeight: 600 });
    var tdCheck      = Object.assign({}, S.tdCenter, { width: 36 });

    var badgeBase = { display: "inline-block", padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, minWidth: 28, textAlign: "center" };
    var badgeWon  = Object.assign({}, badgeBase, { background: colors.successLt, color: colors.success });
    var badgeDraw = Object.assign({}, badgeBase, { background: colors.amberLt,   color: colors.amber   });
    var badgeLost = Object.assign({}, badgeBase, { background: colors.dangerLt,  color: colors.danger  });

    // ── CSB type toggle styles ─────────────────────────────────────────────────
    var toggleWrap = {
      display: "flex",
      gap: 8,
      justifyContent: "center",
      margin: "16px 0 4px",
    };

    function toggleBtn(type, label, color) {
      var active = csbType === type;
      return (
        <button
          key={type}
          type="button"
          onClick={function() { onCupShieldBowlTypeChange(type); }}
          style={{
            padding: "6px 22px",
            borderRadius: 20,
            border: "2px solid " + color,
            background: active ? color : "transparent",
            color: active ? "#fff" : color,
            fontWeight: 700,
            fontSize: 13,
            cursor: "pointer",
            transition: "all 0.15s",
            fontFamily: "inherit",
          }}
        >
          {label}
        </button>
      );
    }

    return (
      <div style={S.overlay}>
        <div style={leaderboardModal}>
          {/* Header */}
          <div style={card.header}>
            <h3 style={card.title}>Leaderboard</h3>
            <button style={S.closeBtn} type="button" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>

          {/* Body */}
          <div style={S.body}>
            {leaderboard_loading ? (
              <div style={table.wrap}>
                <table style={table.table}>
                  <thead>
                    <tr>
                      {["", "#", "Team", "Played", "Won", "Draw", "Lost", "For", "Against", "Diff", "Points", ""].map(
                        function (h, i) { return <th key={i} style={table.th}>{h}</th>; }
                      )}
                    </tr>
                  </thead>
                  <tbody>{this.renderSkeletonRows(6)}</tbody>
                </table>
              </div>
            ) : (
              leader_board.map(function (group, key) {
                return (
                  <div key={key} style={S.groupWrap}>
                    {leader_board.length > 1 && (
                      <div style={S.groupLabel}>{group.group}</div>
                    )}
                    <div style={table.wrap}>
                      <table style={table.table}>
                        <thead>
                          <tr>
                            <th style={thCheck} title={"Select for Knockout / " + csbType.charAt(0).toUpperCase() + csbType.slice(1)}></th>
                            <th style={thRank}>#</th>
                            <th style={table.th}>Team</th>
                            <th style={thCenter}>Played</th>
                            <th style={thCenter}>Won</th>
                            <th style={thCenter}>Draw</th>
                            <th style={thCenter}>Lost</th>
                            <th style={thCenter}>For</th>
                            <th style={thCenter}>Against</th>
                            <th style={thCenter}>Diff</th>
                            <th style={thCenterBrand}>Points</th>
                          </tr>
                        </thead>
                        <tbody>
                          {group.group_leader_board_score.map(function (team, index) {
                            var isChecked = safeSelectedRows.some(function(r) {
                              return String(r.team_id) === String(team.team_id);
                            });
                            return (
                              <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                                <td style={tdCheck}>
                                  <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={function(e) { onHandleKnockout(e, team); }}
                                    style={{ cursor: "pointer", accentColor: csbColor }}
                                  />
                                </td>
                                <td style={tdRank}>{index + 1}</td>
                                <td style={tdTeam}>{team.name}</td>
                                <td style={S.tdCenter}>{team.matches_played}</td>
                                <td style={S.tdCenter}><span style={badgeWon}>{team.won}</span></td>
                                <td style={S.tdCenter}><span style={badgeDraw}>{team.draw}</span></td>
                                <td style={S.tdCenter}><span style={badgeLost}>{team.lose}</span></td>
                                <td style={S.tdCenter}>{team.for}</td>
                                <td style={S.tdCenter}>{team.against}</td>
                                <td style={S.tdCenter}>{team.difference}</td>
                                <td style={S.tdPoints}>{team.points}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })
            )}

            {/* Zone selector */}
            {zones && zones.length > 0 && (
              <div style={S.zoneRow}>
                <label style={S.zoneLabel}>Choose Zone</label>
                <select
                  value={selected_zone}
                  onChange={function(e) { onZoneChange(e.target.value); }}
                  style={form.select}
                >
                  {zones.map(function (zone, index) {
                    return <option key={index} value={zone.value}>{zone.name}</option>;
                  })}
                </select>
              </div>
            )}

            {/* CSB type toggle */}
            <div style={toggleWrap}>
              {toggleBtn('cup',    'Cup',    '#f59e0b')}
              {toggleBtn('shield', 'Shield', '#6366f1')}
              {toggleBtn('bowl',   'Bowl',   '#10b981')}
            </div>
          </div>

          {/* Footer */}
          <div style={S.footer}>
            {knockout_matches_created == false && (
              <button
                onClick={onClickCreate}
                type="button"
                style={btn.primary}
              >
                Create Knockout Fixture
              </button>
            )}
            <button
              onClick={onClickCreateCupShieldBowl}
              type="button"
              disabled={safeSelectedRows.length === 0}
              style={Object.assign({}, btn.primary, {
                background: safeSelectedRows.length === 0 ? '#94a3b8' : csbColor,
                borderColor: safeSelectedRows.length === 0 ? '#94a3b8' : csbColor,
                cursor: safeSelectedRows.length === 0 ? 'not-allowed' : 'pointer',
                marginLeft: 8,
              })}
            >
              {'Create ' + csbType.charAt(0).toUpperCase() + csbType.slice(1) + ' Tournament'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

// ── Classic Leaderboard Popup (League / Round-Robin) ──────────────────────────

export class LeaderBoardPopup extends PureComponent {
  static propTypes = {
    leader_board: PropTypes.array.isRequired,
    competition_game: PropTypes.object,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    const { leader_board, competition_game, onClose } = this.props;

    // Badminton (id=2): no Draw column
    var isBadminton = competition_game && competition_game.id == 2;

    var leaderboardModal = Object.assign({}, S.modal, { maxWidth: 860 });

    var tdTeam = Object.assign({}, table.tdBold, {
      padding: "10px 12px",
      whiteSpace: "normal",
      wordBreak: "break-word",
      maxWidth: 180,
    });

    var thCenter = Object.assign({}, table.th, { textAlign: "center" });
    var thCenterBrand = Object.assign({}, table.th, { textAlign: "center", color: colors.brand });
    var thRank = Object.assign({}, table.th, { textAlign: "center", width: 36 });
    var tdRank = Object.assign({}, S.tdCenter, { width: 36, fontWeight: 600 });

    var badgeBase = { display: "inline-block", padding: "2px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, minWidth: 28, textAlign: "center" };
    var badgeWon  = Object.assign({}, badgeBase, { background: colors.successLt, color: colors.success });
    var badgeDraw = Object.assign({}, badgeBase, { background: colors.amberLt,   color: colors.amber   });
    var badgeLost = Object.assign({}, badgeBase, { background: colors.dangerLt,  color: colors.danger  });

    return (
      <div style={S.overlay} onClick={onClose}>
        <div style={leaderboardModal} onClick={function (e) { e.stopPropagation(); }}>
          {/* Header */}
          <div style={card.header}>
            <h3 style={card.title}>Leaderboard</h3>
            <button style={S.closeBtn} type="button" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>

          {/* Body */}
          <div style={S.body}>
            {leader_board.map(function (group, key) {
              return (
                <div key={key} style={S.groupWrap}>
                  {leader_board.length > 1 && (
                    <div style={S.groupLabel}>{group.group}</div>
                  )}
                  <div style={table.wrap}>
                    <table style={table.table}>
                      <thead>
                        <tr>
                          <th style={thRank}>#</th>
                          <th style={table.th}>Team</th>
                          <th style={thCenter}>Played</th>
                          <th style={thCenter}>Won</th>
                          {!isBadminton && <th style={thCenter}>Draw</th>}
                          <th style={thCenter}>Lost</th>
                          <th style={thCenter}>For</th>
                          <th style={thCenter}>Against</th>
                          <th style={thCenter}>Diff</th>
                          <th style={thCenterBrand}>Points</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.group_leader_board_score.map(function (team, index) {
                          return (
                            <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                              <td style={tdRank}>{index + 1}</td>
                              <td style={tdTeam}>{team.name}</td>
                              <td style={S.tdCenter}>{team.matches_played}</td>
                              <td style={S.tdCenter}><span style={badgeWon}>{team.won}</span></td>
                              {!isBadminton && <td style={S.tdCenter}><span style={badgeDraw}>{team.draw}</span></td>}
                              <td style={S.tdCenter}><span style={badgeLost}>{team.lose}</span></td>
                              <td style={S.tdCenter}>{team.for}</td>
                              <td style={S.tdCenter}>{team.against}</td>
                              <td style={S.tdCenter}>{team.difference}</td>
                              <td style={S.tdPoints}>{team.points}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div style={S.footer}>
            <button style={btn.cancel} type="button" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureScreen/LeaderBoardPopup.js